import { tw, variants } from 'classname-variants';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { createElement } from 'react';

export type BoxProps = React.HTMLAttributes<HTMLDivElement> & {
  as: string;
  className?: string;
  children: ReactNode | ReactNode[];
  ref?: React.RefObject<HTMLDivElement>;
  colourScheme?: 'white' | 'darkGreen' | 'grey' | string | number | undefined;
  bkg?: boolean;
  insetBkg?: boolean;
  highlightBkg?: boolean;
  shadow?: boolean;
  border?: boolean;
  blockSpacing?: boolean;
  breakout?: boolean;
  spacer?: boolean;
  overlayOverBkg?: boolean;
};

const boxVariants = variants({
  variants: {
    blockSpacing: {
      true: tw`px-5`,
    },
    overlayOverBkg: {
      true: tw`relative z-20`,
    },
    breakout: {
      true: tw`max-w-screen relative left-[50%] right-[50%] -ml-[50vw] -mr-[50vw] w-screen`,
    },
  },
});

export const Box = ({
  as = 'div',
  className,
  blockSpacing = false,
  breakout = false,
  colourScheme,
  bkg = false,
  insetBkg = false,
  highlightBkg = false,
  spacer = false,
  shadow = false,
  border = false,
  overlayOverBkg = false,
  ref,
  children,
  ...rest
}: BoxProps) => {
  if (!children && !spacer) {
    return null;
  }

  return createElement(
    as,
    {
      className: classNames(
        boxVariants({
          blockSpacing,
          breakout,
          overlayOverBkg,
          overlayOverBkg,
        }),
        colourScheme && `ff-${colourScheme}`,
        bkg && 'ff-bkg',
        insetBkg && 'ff-insetBkg',
        highlightBkg && 'ff-highlightBkg',
        shadow && 'ff-shadow',
        border && 'ff-border',
        className
      ),
      ref,
      ...rest,
    },
    children
  );
};
